{
  "iframeWaitingMessage": "Obrigado por esperar. Só mais alguns momentos...",
  "otherOrganizations": "Outras organizações",
  "solutionIframe": "Conteúdo principal",
  "unloadPromptMessage": "Tem certeza?"
}
